module.exports = __webpack_public_path__ + "img/Antonia&Stephan-07.78a96390.jpg";